import React, { useCallback } from 'react'
import { I18n } from 'react-redux-i18n'
import { useSelector } from 'react-redux'
import { toastMessage } from 'utils/messages'

import ContainerBox from '../components/ContainerBox'
import SwitchControl from '../components/SwitchControl'
import { sentimentAPI } from 'api'

function SentimentAnalysisSwitch() {
  const { isActive } = useSelector((store) => store.modules.sentimentAnalysis)

  const onChange = useCallback(async (value) => {
    try {
      await sentimentAPI.activate({ isActive: value })

      toastMessage(I18n.t('configurations_sentiment_analysis_save'))
    } catch(error) {
      toastMessage(I18n.t('configurations_sentiment_analysis_save_error'), 'error')
    }
  }, [])

  return (
    <ContainerBox
      title={I18n.t(`configuration_messages_sentiment_containerTitle`)}
    >
      <SwitchControl
        value={isActive}
        onChange={onChange}
      />
    </ContainerBox>
  )
}

export default SentimentAnalysisSwitch
